<template>
  <div class="con">
    <div class="con-wrap">
      <div class="con_title">{{ title }}</div>
			<div class="con_list">
				<div class="number-list">
					<div class="des" v-for="(item, index) in numberList" :key="index">
						<span class="text1">{{item.num}}</span>
						<span class="text2">项</span>
						<span class="text3">{{item.numText}}</span>
					</div>
				</div>
				<div class="text-list clearfix">
					<div :class="['text', index < 4 ? 'mb-30' : '']"  v-for="(item, index) in textList" :key="index">
						<img class="img" :src="item.iconUrl">
						<div class="text1">{{item.contitle}}</div>
						<div class="text2" v-for="(subitem, subindex) in item.descList" :key="subindex">{{ subitem }}</div>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    numberList: Array,
		textList: Array,
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.clearfix:after {
	content: '';
	display: block;
	height: 0;
	clear: both;
	visibility: hidden;
}
.con {
	background-color: #FCFCFC;
	padding: 60px 0;
	.con-wrap {
		width: 1200px;
		margin: 0 auto;
		.con_title {
			font-size: 36px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			line-height: 50px;
			margin-bottom: 60px;
			text-align: center;
		}
		.con_list {
			width: 100%;
			.number-list {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 50px;
				.des {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 328px;
					height: 74px;
					background: #FFFFFF;
					box-shadow: 2px 4px 9px 0px rgba(0, 0, 0, 0.09);
					border-left: 13px solid #E61717;
					.text1 {
						font-size: 40px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #E61717;
						line-height: 56px;
					}
					.text2 {
						font-size: 16px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #E61717;
						line-height: 22px;
						margin-left: 8px;
						margin-right: 8px;
						margin-top: 10px;
					}
					.text3 {
						font-size: 28px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 40px;
					}
				}
			}
			.text-list {
				width: 100%;
				.mb-30 {
					margin-bottom: 40px;
				}
				.text {
					float: left;
					position: relative;
					width: 300px;
					height: 288px;
					padding-top: 20px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: flex-start;
					&::after {
						position: absolute;
            content: ' ';
						width: 1px;
						height: 170px;
						border: 1px solid rgba(153, 153, 153, 0.3);
						right: 0;
						top: 50%;
						margin-top: -85px;
					}
					.img {
						width: 30px;
						height: 30px;
						margin-bottom: 24px;
					}
					.text1 {
						font-size: 20px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 28px;
						margin-bottom: 10px;
					}
					.text2 {
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
						line-height: 28px;
					} 
				}
			}
		}
	}
}
</style>
